import React from "react";

const V2Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 22C7 21.5 4.69498 19.8248 3.66196 18.2236C2.62893 16.6225 2.05515 14.7822 2 12.8932C2 6.87379 7.81552 2 14.99 2C22.1645 2 28 6.87379 28 12.8932C27.9627 14.7693 27.4116 16.6019 26.4035 18.2025C25.3955 19.8031 23 22 20.5 22"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M22.9999 13.7555C23.0071 12.7447 22.7122 11.7582 22.1587 10.9411C21.6052 10.124 20.8223 9.51957 19.9253 9.21676C19.0283 8.91394 18.0646 8.92875 17.176 9.25901C16.2874 9.58927 15.5209 10.2175 14.9894 11.0513C14.5982 10.4486 14.0815 9.95256 13.4804 9.60255C12.8794 9.25255 12.2106 9.05829 11.5274 9.03525C10.8441 9.0122 10.1654 9.16102 9.54508 9.46984C8.92481 9.77866 8.38019 10.2389 7.9546 10.814C7.52902 11.3891 7.23423 12.0631 7.09373 12.7823C6.95323 13.5015 6.97089 14.2461 7.14532 14.9567C7.31974 15.6672 7.6461 16.3242 8.09841 16.8752C8.55071 17.4262 9.11645 17.8561 9.75056 18.1305C9.39511 19.0476 9.21006 20.0306 9.20585 21.0242C9.12262 22.7739 9.68515 24.4882 10.7711 25.7945C11.8572 27.1007 13.3788 27.8934 15.0054 28C16.632 27.8934 18.1537 27.1007 19.2397 25.7945C20.3257 24.4882 20.8882 22.7739 20.805 21.0242C20.8161 20.0285 20.6474 19.0399 20.3084 18.1132C21.1067 17.7532 21.7882 17.1473 22.2671 16.372C22.746 15.5966 23.0009 14.6863 22.9999 13.7555V13.7555Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M12.5 20C13.8807 20 15 18.8807 15 17.5C15 16.1193 13.8807 15 12.5 15C11.1193 15 10 16.1193 10 17.5C10 18.8807 11.1193 20 12.5 20Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M17.5 20C18.8807 20 20 18.8807 20 17.5C20 16.1193 18.8807 15 17.5 15C16.1193 15 15 16.1193 15 17.5C15 18.8807 16.1193 20 17.5 20Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default V2Icon;
